export const IGNORE_FOLDER = ["__MACOSX"];
